import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinService {

  private baseUrl = `${environment.Server_URL}/spin`;

  constructor(private http: HttpClient) { }

  /**
   * 🎡 Spin the wheel
   */
  spin(user_id: number): Observable<any> {
    return this.http.post(this.baseUrl, {
      user_id
    });
  }

  /**
   * 🎁 Get active reward (before order)
   */
  getActive(user_id: | null): Observable<any> {
    return this.http.post(`${this.baseUrl}/active`, {
      user_id
    });
  }

  /**
   * ✅ Consume reward after order
   */
  consume(user_id: number, order_id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/consume`, {
      user_id,
      order_id
    });
  }
}
